/** Shared copy for Beentara admin legal pages — https://beentara.com */

export const LEGAL_SITE_URL = "https://beentara.com/";
export const LEGAL_PRIVACY_EMAIL = "privacy@beentara.com";
export const LEGAL_SUPPORT_EMAIL = "hello@beentara.com";
export const LEGAL_LAST_UPDATED = "14 June 2026";

export const BEENTARA_PRODUCT_SUMMARY =
  "Beentara is an e-commerce operations platform that helps businesses manage their online store, customers, orders, inventory, invoicing, receipts, expenses, CRM, staff, admissions (where enabled), and related day-to-day operations from a unified admin panel.";
